import { AppRoutes } from "./router";
import { BrowserRouter } from "react-router-dom";
import { BirthInfoProvider } from "./contexts/BirthInfoContext";
import { TokenProvider } from "./contexts/TokenContext";

function App() {
  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <TokenProvider>
        <BirthInfoProvider>
          <AppRoutes />
        </BirthInfoProvider>
      </TokenProvider>
    </BrowserRouter>
  );
}

export default App;